<div class="db-cdn-original-server">
  <h4 class="db-cdn-original-server__title">Original server IP</h4>
  <p class="db-cdn-original-server__desc mt4">Change your original server IP</p>

  <div class="ds-input-wrap db-cdn-original-server-ip mt20" [ngClass]="{'pb0': !userSubscription?.trialBoosterClient && !userSubscription?.boosterProClient}">
    <input type="text" class="ds-input" placeholder="{{cfData?.originalRecord}}"
           [formControl]="originalRecord" [ngClass]="{'disabled': !userSubscription?.trialBoosterClient && !userSubscription?.boosterProClient}">
    <a class="ds-btn-green" *ngIf="userSubscription?.trialBoosterClient || userSubscription?.boosterProClient"
       [ngClass]="{'ds-btn-disabled': loading || originalRecord?.value === cfData?.originalRecord}"
       (click)="updateOriginalIp()" >
      <span *ngIf="!loading">Update</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </a>
  </div>
</div>
<div class="db-cdn-original-server__dns" *ngIf="userSubscription?.trialBoosterClient || userSubscription?.boosterProClient || !defaultRecord?.tenwebNs">
  <div>
    <b class="db-cdn-original-server__desc bold">DNS records</b>
    <p class="db-cdn-original-server__desc mt4">The DNS records needed to proxy your site.</p>
  </div>
  <button class="ds-btn-outline-green"  [ngClass]="{'ds-btn-disabled': initialDisabledBtn}" (click)="showDnsRecords()">
    <span>View Records</span>
  </button>
</div>
